import {
  Squircle as SquircleBase,
  StaticSquircle as StaticSquircleBase,
} from '@squircle-js/react';
import type { ComponentProps } from 'react';

/**
 * Кит Figma задаёт corner smoothing 100% на всех скруглённых формах —
 * это ровно `cornerSmoothing={1}` библиотеки (полная суперэллипса,
 * как в иконках iOS). Значение фиксируем здесь, чтобы не повторять
 * в каждом компоненте.
 */
const CORNER_SMOOTHING = 1;

type SquircleProps = Omit<ComponentProps<typeof SquircleBase>, 'cornerSmoothing'>;

/** Для элементов без фиксированного размера в px (ширина 100%, flex). */
export function Squircle(props: SquircleProps) {
  return <SquircleBase cornerSmoothing={CORNER_SMOOTHING} {...props} />;
}

type StaticSquircleProps = Omit<
  ComponentProps<typeof StaticSquircleBase>,
  'cornerSmoothing'
>;

/** Для элементов с известным из макета фиксированным размером (быстрее — без ResizeObserver). */
export function StaticSquircle(props: StaticSquircleProps) {
  return <StaticSquircleBase cornerSmoothing={CORNER_SMOOTHING} {...props} />;
}
